import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button, Divider } from 'semantic-ui-react'
import { useAxios } from 'contexts'
import { HalResource, Selection } from 'types'
import Layout from 'component/layout'
import SelectionInputForm from './InputForm'

type Props = {
  question_id: string
}

type Add = {
  key: string
}

const BulkInput: React.FC<Props> = props => {
  const { question_id } = props
  const { axios } = useAxios()
  const [loading, setLoading] = useState(false)
  const [dataList, setDataList] = useState<Selection[]>([])
  const [addingList, setAddingList] = useState<Add[]>([])
  const [refresh, setRefresh] = useState(0)

  const BASE_PATH = `/crud/question/${question_id}/selections`

  const handleRefresh = () => setRefresh(state => ++state)

  useEffect(() => {
    const getApi = async () => {
      setLoading(true)
      const { data, error } = await axios.get<HalResource<Selection>>(
        `${BASE_PATH}`
      )
      setLoading(false)
      if (error) {
        console.log('get error', error)
        return
      }

      const list = data?._embedded?.[_.keys(data._embedded)[0]]
      setDataList(list || [])
    }

    getApi()
  }, [BASE_PATH, setDataList, refresh])

  return (
    <Layout.Page title='選択肢' loading={loading}>
      {_(dataList)
        .map(selection => (
          <SelectionInputForm
            key={selection.id}
            mode='edit'
            question_id={question_id}
            selection_id={_.toString(selection.id)}
            onSave={() => {
              handleRefresh()
            }}
          />
        ))
        .value()}

      {_(addingList)
        .map(data => (
          <SelectionInputForm
            key={data.key}
            mode='new'
            question_id={question_id}
            onSave={() => {
              setAddingList(list =>
                _(list)
                  .filter(elem => elem.key !== data.key)
                  .value()
              )
              handleRefresh()
            }}
            handleCancel={() =>
              setAddingList(list =>
                _(list)
                  .filter(elem => elem.key !== data.key)
                  .value()
              )
            }
          />
        ))
        .value()}

      <Divider />

      <Button
        primary
        icon='plus'
        content='Add Selection'
        onClick={() =>
          setAddingList(list => [...list, { key: _.uniqueId() } as Add])
        }
      />
    </Layout.Page>
  )
}

export default BulkInput
